
import { BigFiveQuestion } from '@/types/personality';

// The standard Big Five test questions (50 items)
export const bigFiveQuestions: BigFiveQuestion[] = [
  // Openness to Experience (O)
  { id: 1, text: "Tenho uma imaginação vívida", domain: "O", reversed: false },
  { id: 2, text: "Tenho dificuldade para entender ideias abstratas", domain: "O", reversed: true },
  { id: 3, text: "Tenho ideias originais", domain: "O", reversed: false },
  { id: 4, text: "Sou pouco interessado(a) em reflexões abstratas", domain: "O", reversed: true },
  { id: 5, text: "Tenho um vocabulário rico", domain: "O", reversed: false },
  { id: 6, text: "Não tenho um bom senso artístico", domain: "O", reversed: true },
  { id: 7, text: "Sou curioso(a) sobre muitas coisas diferentes", domain: "O", reversed: false },
  { id: 8, text: "Aprecio arte e beleza", domain: "O", reversed: false },
  { id: 9, text: "Prefiro rotina a novas experiências", domain: "O", reversed: true },
  { id: 10, text: "Gosto de refletir e brincar com ideias", domain: "O", reversed: false },

  // Conscientiousness (C)
  { id: 11, text: "Sou sempre preparado(a)", domain: "C", reversed: false },
  { id: 12, text: "Deixo meus pertences fora do lugar", domain: "C", reversed: true },
  { id: 13, text: "Presto atenção aos detalhes", domain: "C", reversed: false },
  { id: 14, text: "Faço bagunça nas minhas coisas", domain: "C", reversed: true },
  { id: 15, text: "Gosto de ordem", domain: "C", reversed: false },
  { id: 16, text: "Esqueço de guardar as coisas no lugar", domain: "C", reversed: true },
  { id: 17, text: "Sigo um cronograma", domain: "C", reversed: false },
  { id: 18, text: "Sou exigente no meu trabalho", domain: "C", reversed: false },
  { id: 19, text: "Procrastino tarefas importantes", domain: "C", reversed: true },
  { id: 20, text: "Cumpro minhas promessas", domain: "C", reversed: false },

  // Extraversion (E)
  { id: 21, text: "Sou a alma da festa", domain: "E", reversed: false },
  { id: 22, text: "Não falo muito", domain: "E", reversed: true },
  { id: 23, text: "Sinto-me confortável perto das pessoas", domain: "E", reversed: false },
  { id: 24, text: "Mantenho-me em segundo plano", domain: "E", reversed: true },
  { id: 25, text: "Inicio conversas", domain: "E", reversed: false },
  { id: 26, text: "Tenho pouco a dizer", domain: "E", reversed: true },
  { id: 27, text: "Falo com muitas pessoas em festas", domain: "E", reversed: false },
  { id: 28, text: "Não gosto de chamar atenção para mim", domain: "E", reversed: true },
  { id: 29, text: "Não me importo de ser o centro das atenções", domain: "E", reversed: false },
  { id: 30, text: "Sou quieto(a) com estranhos", domain: "E", reversed: true },

  // Agreeableness (A)
  { id: 31, text: "Sinto empatia pelos sentimentos dos outros", domain: "A", reversed: false },
  { id: 32, text: "Não me interesso pelos problemas alheios", domain: "A", reversed: true },
  { id: 33, text: "Tenho um coração mole", domain: "A", reversed: false },
  { id: 34, text: "Não me preocupo muito com os outros", domain: "A", reversed: true },
  { id: 35, text: "Dedico tempo para os outros", domain: "A", reversed: false },
  { id: 36, text: "Sinto pouca preocupação com os outros", domain: "A", reversed: true },
  { id: 37, text: "Faço as pessoas se sentirem à vontade", domain: "A", reversed: false },
  { id: 38, text: "Insulto pessoas", domain: "A", reversed: true },
  { id: 39, text: "Interesso-me pela vida das pessoas", domain: "A", reversed: false },
  { id: 40, text: "Sou duro(a) com os outros", domain: "A", reversed: true },

  // Neuroticism (N)
  { id: 41, text: "Fico estressado(a) facilmente", domain: "N", reversed: false },
  { id: 42, text: "Sou relaxado(a) na maioria das situações", domain: "N", reversed: true },
  { id: 43, text: "Preocupo-me com as coisas", domain: "N", reversed: false },
  { id: 44, text: "Raramente me sinto triste", domain: "N", reversed: true },
  { id: 45, text: "Facilmente me perturbo", domain: "N", reversed: false },
  { id: 46, text: "Fico irritado(a) facilmente", domain: "N", reversed: false },
  { id: 47, text: "Mudo meu humor frequentemente", domain: "N", reversed: false },
  { id: 48, text: "Tenho frequentes mudanças de humor", domain: "N", reversed: false },
  { id: 49, text: "Fico nervoso(a) facilmente", domain: "N", reversed: false },
  { id: 50, text: "Sou tranquilo(a) a maior parte do tempo", domain: "N", reversed: true }
];

// Short version of the test (20 items - 4 per domain)
export const bigFiveQuestionsShort: BigFiveQuestion[] = [
  // Openness
  { id: 1, text: "Tenho uma imaginação vívida", domain: "O", reversed: false },
  { id: 3, text: "Tenho ideias originais", domain: "O", reversed: false },
  { id: 5, text: "Tenho um vocabulário rico", domain: "O", reversed: false },
  { id: 9, text: "Prefiro rotina a novas experiências", domain: "O", reversed: true },
  
  // Conscientiousness
  { id: 11, text: "Sou sempre preparado(a)", domain: "C", reversed: false },
  { id: 13, text: "Presto atenção aos detalhes", domain: "C", reversed: false },
  { id: 15, text: "Gosto de ordem", domain: "C", reversed: false },
  { id: 19, text: "Procrastino tarefas importantes", domain: "C", reversed: true },
  
  // Extraversion
  { id: 21, text: "Sou a alma da festa", domain: "E", reversed: false },
  { id: 23, text: "Sinto-me confortável perto das pessoas", domain: "E", reversed: false },
  { id: 25, text: "Inicio conversas", domain: "E", reversed: false },
  { id: 30, text: "Sou quieto(a) com estranhos", domain: "E", reversed: true },
  
  // Agreeableness
  { id: 31, text: "Sinto empatia pelos sentimentos dos outros", domain: "A", reversed: false },
  { id: 33, text: "Tenho um coração mole", domain: "A", reversed: false },
  { id: 35, text: "Dedico tempo para os outros", domain: "A", reversed: false },
  { id: 38, text: "Insulto pessoas", domain: "A", reversed: true },
  
  // Neuroticism
  { id: 41, text: "Fico estressado(a) facilmente", domain: "N", reversed: false },
  { id: 43, text: "Preocupo-me com as coisas", domain: "N", reversed: false },
  { id: 45, text: "Facilmente me perturbo", domain: "N", reversed: false },
  { id: 50, text: "Sou tranquilo(a) a maior parte do tempo", domain: "N", reversed: true }
];

// Population normative data for score normalization
export const normativeData = {
  O: { mean: 3.5, standardDeviation: 0.7 },
  C: { mean: 3.4, standardDeviation: 0.7 },
  E: { mean: 3.2, standardDeviation: 0.8 },
  A: { mean: 3.7, standardDeviation: 0.6 },
  N: { mean: 2.9, standardDeviation: 0.8 }
};
